import { useState } from 'react';
import { FIFTEEN_SECONDS } from '../../util/durations';
import Dialog from '@ifit/react-components/dist/Dialog';
import Snackbar from '@ifit/react-components/dist/Snackbar';
import { Text } from './text';
import './index.scss';

type IError = {
  from: string;
  stack: string;
};

interface IProps {
  error: IError;
  message: string;
  title?: string;
}

export default function SnackbarError({ error, message, title }: IProps): JSX.Element {
  const [open, setOpen] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClick = (): void => {
    setOpen(false);
    setOpenDialog(true);
  };

  const handleClose = (): void => {
    setOpenDialog(false);
  };

  if (!error) {
    return null;
  }

  return (
    <div className="error">
      {openDialog && (
        <div className="overlay">
          <Dialog
            heading={title}
            primaryAction={handleClose}
            primaryLabel={Text.closeModal}
            message={error.stack}
            className="error-dialog"
          >
            <p>Initiated from: {error.from}</p>
          </Dialog>
        </div>
      )}

      <Snackbar
        open={open}
        message={message}
        primaryLabel={Text.openModal}
        primaryAction={handleClick}
        autoHideDuration={FIFTEEN_SECONDS}
      />
    </div>
  );
}
